module.exports = __webpack_public_path__ + "static/media/logo_green_tm.d33f14ff.png";